
const local = {
  url: {

    BOC_URL: 'http://localhost:8888/boc/',
    FILE_UPLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/boc/file-upload",
    FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
    FILE_VIEW_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/pdf-file-download/",
    FILE_UPLOAD_OPEN: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/",
    payment_url: 'https://test.epay.sbiuat.bank.in/secure/AggregatorHostedListener',

  }
};

const prod = {
  url: {
    CFMS_URL: 'https://api.dev.herb.apcfss.in/',
    BOC_URL: 'https://bocdevapi.apcfss.in/',
    FILE_UPLOAD_OPEN: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/",

  }
};
const dev = {
  url: {
    FILE_UPLOAD_OPEN: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/",
    FILE_UPLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/boc/file-upload",
    FILE_VIEW_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/pdf-file-download/",
    FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
    BOC_URL: 'https://swapi.dev.nidhi.apcfss.in/boc/',
    payment_url: 'https://test.epay.sbiuat.bank.in/secure/AggregatorHostedListener',
  }
};

const sdc = {
  url: {
    FILE_UPLOAD_URL: "https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-upload/",
    FILE_VIEW_URL: "https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
    FILE_DOWNLOAD_URL: "https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
    BOC_URL: 'https://boc.ap.gov.in/bocapi/',
    FILE_UPLOAD_OPEN: "https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-upload/",
    payment_url: 'https://epay.sbi.bank.in/secure/AggregatorHostedListener',

  }
};

const hostname = window.location.hostname


//export const config = process.env.NODE_ENV === 'development' ? local : dev;
export const config = process.env.NODE_ENV === 'development' ? sdc : hostname === 'boc.dev.nidhi.apcfss.in' ? dev : sdc;

// process.env.REACT_APP_ENV === 'sdc'? sdc: dev; // default
























